export const getApplicationSeekReferenceStatus = (
  referenceChecks:
    | {
        case: 'REQUESTED';
      }
    | {
        case: 'NOT_REQUESTED';
      }
    | {
        case: 'LIMITED_AVAILABLE';
      }
    | {
        case: 'STANDARD_AVAILABLE';
      },
) => {
  if (referenceChecks.case === 'STANDARD_AVAILABLE') {
    return 'standard';
  }

  if (referenceChecks.case === 'LIMITED_AVAILABLE') {
    return 'limited';
  }

  return null;
};
